'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'bullseye-arrow';
var width = 576;
var height = 512;
var aliases = [127919];
var unicode = 'f648';
var svgPathData = 'M386.7 64.2c-1.7-10.2 1.6-20.6 8.9-27.9l51.2-51.2C455-23 468.8-20.1 473-9.5L496 48 553.5 71c10.7 4.3 13.5 18 5.4 26.2l-51.2 51.2c-7.3 7.3-17.7 10.6-27.9 8.9L429.1 148.9 305 273c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l124.1-124.1-8.4-50.7zM489.9 205.6c16.4-1 32.2-7 45.1-17.3 5.9 21.6 9.1 44.3 9.1 67.8 0 141.4-114.6 256-256 256S32 397.4 32 256 146.6 0 288 0c23.5 0 46.2 3.2 67.8 9.1-10.3 12.9-16.4 28.7-17.3 45.1-16.1-4-33-6.2-50.4-6.2-114.9 0-208 93.1-208 208s93.1 208 208 208 208-93.1 208-208c0-17.4-2.1-34.3-6.2-50.4zM288 112c12.9 0 25.4 1.7 37.3 4.9L282 160.2c-50.2 3.1-90 44.8-90 95.8 0 53 43 96 96 96 51 0 92.7-39.8 95.8-90l43.3-43.3c3.2 11.9 4.9 24.4 4.9 37.3 0 79.5-64.5 144-144 144s-144-64.5-144-144 64.5-144 144-144z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBullseyeArrow = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;